import { ScheduleEntryTypeCategory, ScheduleEntryType } from "domain-entities";
import { getColorHex } from "Helpers/ColorHelper";
import {
	useTranslateScheduleEntryType,
	getScheduleEntryTypeIcon,
} from "Components/ScheduleEntryType/ScheduleEntryTypeHelper";
import { px } from "Configs/theme";

export const TAB_HEIGHT = 40;
export const QUICK_ADD_HEIGHT = 72;

export interface QuickAdd {
	name: string;
	colorHex: string;
	projectId?: string;
	typeId?: string;
	category?: ScheduleEntryTypeCategory;
	icon?: JSX.Element;
}

export function useGetQuickAddsFromScheduleEntryTypes() {
	const translateScheduleEntryType = useTranslateScheduleEntryType();

	return (
		scheduleEntryTypes: ScheduleEntryType[],
		category: ScheduleEntryTypeCategory
	) =>
		scheduleEntryTypes.reduce<QuickAdd[]>((result, type) => {
			if (type.category === category && !type.isDeleted) {
				result.push({
					name: translateScheduleEntryType(type),
					colorHex: getColorHex(type.colorTag),
					icon: getScheduleEntryTypeIcon(type.icon, px.xl),
					typeId: type.id,
					category,
				});
			}

			return result;
		}, []);
}

export function getQuickAddViewKey(quickAdd: QuickAdd) {
	return [quickAdd.projectId, quickAdd.typeId].join("-");
}
